import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  resultsContainer: ({ mode }) => {
    if (mode === 'modal') {
      return {
        backgroundColor: theme.colorPalette.beige_25,
        boxShadow: 'none'
      };
    }
  },
  tableRow: {
    height: 48
  },
  cell: {
    display: 'inline',
    height: 48,
    width: '100%'
  }
}));
